import MP from '@/views/admin/materiais-padronizados'
import MPSave from '@/views/admin/materiais-padronizados/Save'
import MPMedidas from '@/views/admin/materiais-padronizados/medida'
import MPMedidaSave from '@/views/admin/materiais-padronizados/medida/Save'
import MPGrupos from '@/views/admin/materiais-padronizados/grupo'
import MPGrupoSave from '@/views/admin/materiais-padronizados/grupo/Save'
import MPSubgrupos from '@/views/admin/materiais-padronizados/subgrupo'
import MPSubgrupoSave from '@/views/admin/materiais-padronizados/subgrupo/Save'

export const materiais = [
  {
    name: 'user_material',
    path: 'material/list',
    component: MP,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_material_save',
    path: 'material/save/:id?',
    component: MPSave,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_material_medida',
    path: 'material/medida/list',
    component: MPMedidas,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_material_medida_save',
    path: 'material/medida/save/:id?',
    component: MPMedidaSave,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_material_grupo',
    path: 'material/grupo/list',
    component: MPGrupos,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_material_grupo_save',
    path: 'material/grupo/save/:id?',
    component: MPGrupoSave,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_material_subgrupo',
    path: 'material/subgrupo/list',
    component: MPSubgrupos,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  },
  {
    name: 'user_material_subgrupo_save',
    path: 'material/subgrupo/save/:id?',
    component: MPSubgrupoSave,
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/materiais.js